import React, { useState } from 'react';
import UnifiedGallery from '../components/UnifiedGallery';
import useStandardGallery from '../hooks/useStandardGallery';

const PlymouthPage = () => {
  const [showMore, setShowMore] = useState(false);
  
  // Use standardized gallery hook with consistent configuration
  const { getGalleryProps } = useStandardGallery('plymouth');

  const handleCelebration = () => {
    setShowMore(!showMore);
  };

  return (
    <div className="page-container-wrapper max-width-default padding-default">
      <div className="page-header">
        <h1>
          <i className="fas fa-map-marker-alt"></i>
          Plymouth, CT. 06782
        </h1>
        <p>Welcome to Plymouth! This historic location holds a special place in American history as the landing site of the Mayflower Pilgrims in 1620.</p>
      </div>

      <div className="page-content">
        <div className="section">
          <p>Welcome to Plymouth! This historic location holds a special place in American history as the landing site of the Mayflower Pilgrims in 1620. Explore the rich heritage and continuing significance of this remarkable place.</p>
        </div>

        {/* Plymouth Gallery */}
        <div className="section">
          <UnifiedGallery 
            {...getGalleryProps("Plymouth")}
          />
        </div>
      </div>
    </div>
  );
};

export default PlymouthPage;
